var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c(_vm.component,{tag:"component",staticClass:"cs-text"},[_vm._l((_vm.paragraphs),function(block,i){return [_c(_vm.htmlBlock(block),{key:i,tag:"component",class:block.cssclass})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }